<template>
  <div :class="['text-' + color, 'flex', 'flex-row', 'font-bold', 'text-date', 'text-right']">
    <p>{{ formattedDate }}</p>
    <p style="width: 12rem;" class="ml-2 date">{{ formattedTime }}</p>
  </div>
</template>

<script>
export default {
  name: "v-datetime",
  props: {
    color: {
      type: String,
      default: "black",
      validator: (value) => ["black", "white"].includes(value),
    },
  },
  data() {
    return {
      current_date_time: new Date(),
    };
  },
  computed: {
    formattedDate() {
      return this.current_date_time.toLocaleDateString(this.$i18n.locale, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    formattedTime() {
      let hours = this.current_date_time.getHours();
      const minutes = this.current_date_time.getMinutes();
      const seconds = this.current_date_time.getSeconds();

      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12;
      hours = hours ? hours : 12;

      const formattedHours = hours < 10 ? `0${hours}` : hours;
      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
      const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
    },
  },
  watch: {
    '$i18n.locale': 'updateDateTime'
  },
  mounted() {
    this.startClock();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    startClock() {
      this.interval = setInterval(() => {
        this.current_date_time = new Date();
      }, 1000);
    },
    updateDateTime() {
      this.current_date_time = new Date();
    }
  },
};
</script>

<style scoped>
@media (min-width: 2500px) {
  .date {width: 13rem !important;}
}

</style>